module.exports = __webpack_public_path__ + "img/20190603162603QQ截图20190524162947.2d1f1c0b.png";